module.exports = '4.10.0';



// WEBPACK FOOTER //
// ./src/version.js